import React, { useEffect, useState, useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Feather, MaterialIcons } from "@expo/vector-icons";
import toast from "../../utils/toast";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { LinearGradient } from "expo-linear-gradient";
import LanguageSelector from "../../components/LanguageSelector";
import { If, Then, Else } from "react-if";
import {
  ActivityIndicator,
  CheckBox,
  Image,
  Linking,
  Modal,
  Switch,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { LanguageContext } from "../../context/LanguageContext";
import Logo from "../../../assets/logo-gpx-ecofi.png";
import ScreenLoader from "../../components/ScreenLoader";
import api from "../../services/api";
import styles from "./styles";

export default function Login({ navigation }) {
  const version = "v5 17/07/2023";
  const [isLoading, setIsLoading] = useState(false);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [modalContent, setModalContent] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [keepLogged, setKeepLogged] = useState(false);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [password, setPassword] = useState("");
  const [checkboxIsSelected, setCheckboxIsSelected] = useState(true);
  const { lang, changeLanguage } = useContext(LanguageContext);

  useEffect(() => {
    if (window.location.hostname === "localhost") {
    }
  }, []);

  useEffect(() => {
    checkLogin();
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    setIsEmailValid(validateEmail(email));
  }, [email]);

  const handleEmailChange = (text) => {
    setEmail(text);
    setIsEmailValid(validateEmail(text));
  };

  const checkLogin = async () => {
    let keep = await AsyncStorage.getItem("keep_logged");
    keep = keep === "true";

    setKeepLogged(keep);
    if (keep /* && keep === "true" */) {
      let emailStorage = await AsyncStorage.getItem("keep_logged_email");
      let pwdStorage = await AsyncStorage.getItem("keep_logged_password");

      setEmail(emailStorage);
      setPassword(pwdStorage);
    }
  };
  const intl = useIntl();

  const handleLogin = async () => {
    if (!email) {
      alert(intl.formatMessage({ id: "login.alertPreencheEmail" }));
      return false;
    }
    if (!password) {
      alert(intl.formatMessage({ id: "login.alertPreencheSenha" }));
      return false;
    }
    if (!checkboxIsSelected) {
      alert(intl.formatMessage({ id: "login.alertAceitaTermos" }));
      return false;
    }

    setIsLoading(true);

    const data = { email, password, version };

    api
      .post("/auth/login", data)
      .then(async (res) => {
        await AsyncStorage.setItem("JWT_TOKEN", res.data.access_token);

        if (keepLogged) {
          await AsyncStorage.setItem("keep_logged", "true");
          await AsyncStorage.setItem("keep_logged_email", email);
          await AsyncStorage.setItem("keep_logged_password", password);
        } else {
          await AsyncStorage.removeItem("keep_logged");
        }

        setEmail("");
        setPassword("");

        setIsLoading(false);

        //TODO: chamar API e obter is_endorder
        const token = await AsyncStorage.getItem("JWT_TOKEN");
        api
          .get(`/clients/getDetails/client`, {
            headers: { Authorization: `Bearer ${res.data.access_token}` },
          })
          .then(async (res) => {
            const user = res.data.name_user[0];
            const client = user.client;
            try {
              await AsyncStorage.setItem("client_country", client.country);
              await AsyncStorage.setItem("lang", client.language);
              changeLanguage(client.language);
            } catch (error) {
              console.error("Erro ao salvar o país no AsyncStorage:", error);
            }
            setIsLoading(false);

            if (client.is_endorser) {
              await AsyncStorage.setItem("is_endorser", "true");
              /* navigation.navigate("WalletEndorser"); */
              navigation.navigate("Home");
            } else {
              await AsyncStorage.setItem("is_endorser", "false");
              navigation.navigate("Home");
            }
          })
          .catch((error) => {
            toast(
              intl.formatMessage({ id: "updateRegistration.erroGeral" }),
              "#DA1414"
            );
            setIsLoading(false);
          });
      })
      .catch((err) => {
        if (
          err.response?.status === 401 &&
          err.response?.data?.error &&
          err.response?.data?.error !== "Unauthorized"
        ) {
          alert(err.response.data.error);
          setIsLoading(false);
          return false;
        }
        if (err.request?.status === 401) {
          alert(intl.formatMessage({ id: "login.alertErroEmailouSenha" }));
          setIsLoading(false);
          return false;
        }
        console.error(err);
        alert(intl.formatMessage({ id: "login.alertErroGenerico" }));
        setIsLoading(false);
      });
  };

  function forgotPassword() {
    const sendForgotPasswordEmail = () => {
      setSpinnerLoading(true);
      api
        .post("auth/reset-password", { email })
        .then((response) => {
          setSpinnerLoading(false);
          alert(intl.formatMessage({ id: "login.alertLinkCadastroNovaSenha" }));
        })
        .catch(({ response }) => {
          setSpinnerLoading(false);
          if (response?.status === 404) {
            const { data } = response;
            alert(data.message);
          } else {
            alert(intl.formatMessage({ id: "login.alertErroInesperado" }));
          }
        })
        .finally(() => setSpinnerLoading(false));
    };
    if (!email) {
      alert(
        intl.formatMessage({ id: "login.alertPreencheEmailRecuperaSenha" })
      );

      setSpinnerLoading(false);
      return false;
    } else {
      if (
        confirm(
          intl.formatMessage({ id: "login.alertRecuperacaoSenha" }, { email })
        )
      ) {
        sendForgotPasswordEmail();
      } else {
        return;
      }
    }
  }
  function handleModalTerms() {
    Linking.canOpenURL("https://api.gpxecofi.com.br/termos-privacidade").then(
      (supported) => {
        if (supported) {
          Linking.openURL("https://api.gpxecofi.com.br/termos-privacidade");
        } else {
          console.error("url blocked", err);
        }
      }
    );
  }
  const [hidePassword, setHidePassword] = useState(true);
  const handleShowPassword = () => {
    setHidePassword(!hidePassword);
  };
  return (
    <View style={styles.container}>
      <LinearGradient
        start={{ x: 1, y: 0.99 }}
        end={{ x: 1, y: 1 }}
        colors={["#077A97", "#A3CED8"]}
        style={styles.background}
      >
        <LanguageSelector />
        <View style={styles.logo}>
          <Image style={styles.imgLogo} source={Logo} />
        </View>

        <View style={styles.actionContainer}>
          <View style={styles.loginForm}>
            <Text style={styles.labelInput}>
              <FormattedMessage id="login.email" />
            </Text>
            <View style={styles.passwordContainer}>
              <FormattedMessage id="login.email">
                {(placeholder) => (
                  <TextInput
                    placeholder={placeholder}
                    value={email}
                    /* onChangeText={setEmail} */
                    onChangeText={handleEmailChange}
                    style={styles.input}
                  />
                )}
              </FormattedMessage>
            </View>
            <Text style={styles.labelInput}>
              <FormattedMessage id="login.senha" />
            </Text>
            <View style={styles.passwordContainer}>
              <FormattedMessage id="login.senha">
                {(placeholder) => (
                  <TextInput
                    placeholder={placeholder}
                    importantForAutofill="no"
                    value={password}
                    secureTextEntry={hidePassword}
                    onChangeText={(value) =>
                      setPassword(value.replace(/[^0-9]/g, ""))
                    }
                    style={styles.input}
                  />
                )}
              </FormattedMessage>
              <TouchableOpacity
                style={styles.eyeButton}
                onPress={handleShowPassword}
              >
                {hidePassword ? (
                  <Feather name="eye" size={16} color="#222" />
                ) : (
                  <Feather name="eye-off" size={16} color="#222" />
                )}
              </TouchableOpacity>
            </View>

            <TouchableOpacity onPress={forgotPassword} disabled={!isEmailValid}>
              <Text
                style={[
                  styles.forgotPasswordText,
                  isEmailValid ? null : { opacity: 0.5 },
                ]}
              >
                <FormattedMessage id="login.esqueciSenha"></FormattedMessage>
              </Text>
            </TouchableOpacity>

            <View style={[styles.keepLogged]}>
              <Switch
                trackColor={{ false: "#767577", true: "#767577" }}
                thumbColor={keepLogged ? "#077A97" : "#f4f3f4"}
                ios_backgroundColor="#3e3e3e"
                onValueChange={setKeepLogged}
                value={keepLogged}
                disabled={isLoading}
              />
              <Text style={{ marginLeft: 10, color: "#077A97" }}>
                <FormattedMessage id="login.permanecerLogado"></FormattedMessage>
              </Text>
            </View>
          </View>
          <View style={styles.checkboxContainer}>
            <CheckBox
              value={checkboxIsSelected}
              onValueChange={setCheckboxIsSelected}
              style={styles.checkbox}
            />
            <View style={styles.checkboxLabelContainer}>
              <Text style={styles.checkboxLabel}>
                <FormattedMessage id="login.aceitaTermos"></FormattedMessage>
              </Text>
            </View>
            <TouchableOpacity
              style={styles.checkboxLabelContainer}
              onPress={() => handleModalTerms()}
            >
              <Text style={styles.termsLink}>
                <FormattedMessage id="login.termosUso"></FormattedMessage>
              </Text>
            </TouchableOpacity>
          </View>
          <TouchableOpacity onPress={handleLogin} style={styles.actionButton}>
            <If condition={isLoading}>
              <Then>
                <ActivityIndicator color="#2797A2" size="large" />
              </Then>
              <Else>
                <Text style={styles.actionButtonText}>
                  <FormattedMessage id="login.btnEntrar"></FormattedMessage>
                </Text>
              </Else>
            </If>
          </TouchableOpacity>

          <ScreenLoader loading={spinnerLoading} />

          <Modal
            animationType="fade"
            transparent={false}
            visible={modalVisible}
            statusBarTranslucent={true}
            onRequestClose={() => setModalVisible((visible) => !visible)}
          >
            <View style={styles.header}>
              <TouchableOpacity
                style={styles.closeButton}
                onPress={() => setModalVisible((visible) => !visible)}
              >
                <Text>
                  <FormattedMessage id="login.btnFechar" />
                </Text>
                <MaterialIcons name="close" size={30} color="black" />
              </TouchableOpacity>
            </View>
            {modalContent}
          </Modal>
        </View>
      </LinearGradient>
    </View>
  );
}
